import { CSSProperties } from 'react';
import { DS_SPACINGS } from '../theme/v4-theme';

export type GapObject = {
  row?: CSSProperties['rowGap'];
  column?: CSSProperties['columnGap'];
};
export type StackGap = CSSProperties['gap'] | GapObject;

export type SpacingObject = {
  row?: keyof typeof DS_SPACINGS;
  column?: keyof typeof DS_SPACINGS;
};

export type StackSpacing = keyof typeof DS_SPACINGS | SpacingObject | 'none';

export const isGapObject = (gap: StackGap): gap is GapObject =>
  typeof gap === 'object' && gap !== null && ('row' in gap || 'column' in gap);
